import 'sweetalert2/src/sweetalert2.scss';
import launchModal from "../index";
import ConfirmationModal from "./modal";
import {t} from "../../../translation";

export const showConfirmation = (text, onApplyClick, isDangerous=false, title='Are you sure?', width=600) => {
    launchModal(ConfirmationModal, {title: t(title), onApplyClick, text, isDangerous}, {width});
};